import React, {useEffect, useState} from 'react';
import {Flex, Image, message, Skeleton} from "antd";
import {Link, useNavigate} from "react-router-dom";
import IntlMessage from "../../components/IntlMessage/IntlMessage";
import {useTranslation} from "react-i18next";
import {Fade} from "react-awesome-reveal";
import useGeoKazakhstan from "../../constants/kz/useGeoKazakhstan";
import {
    MapContainer,
    TileLayer,
    LayersControl,
    Marker,
    Polygon,
    Polyline,
    Rectangle,
    Circle,
    useMapEvents,
    useMap, GeoJSON
} from 'react-leaflet';
import * as d3 from 'd3';
import L, { latLng } from 'leaflet';
import 'leaflet/dist/leaflet.css';
import {clrs} from "../../constants/colors";
import MyText from "../../components/UI/Text/MyText";
import WeatherService from "../../services/WeatherService";
import Card from "../../components/LoadingComponents/Card";
import aituLogo from '../../images/aitu_logo@3x.png';
import sun from '../../images/sun@3x.png';
import flower1 from '../../images/flower@3x.png';
import flower2 from '../../images/flower2@3x.png';
import flower3 from '../../images/flower3@3x.png';
import leaf1 from '../../images/leaf@3x.png';
import leaf2 from '../../images/leaf2@3x.png';
import leaf3 from '../../images/leaf3@3x.png';
import bottom_zigzag from '../../images/bottom_zigzag@3x.png';
const { BaseLayer } = LayersControl;
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: 'https://unpkg.com/leaflet@1.6/dist/images/marker-icon-2x.png',
    iconUrl: 'https://unpkg.com/leaflet@1.6/dist/images/marker-icon.png',
    shadowUrl: 'https://unpkg.com/leaflet@1.6/dist/images/marker-shadow.png',
});
const ArgoGisPage = () => {

    const kazakhstan = useGeoKazakhstan();

    const {t} = useTranslation();

    const navigate = useNavigate();

    const [selectedPoint, setSelectedPoint] = useState(null);
    const [weather, setWeather] = useState(null);
    const [loading, setLoading] = useState(false);

    const style = (feature) => {
        if (feature.properties.NAME_1 === "Pavlodar") {
            return {
                color: 'blue', // border color
                weight: 3,
                fillOpacity: 0
            };
        }
        return {
            color: clrs.whiterBlacker,
        };
    };

    const onEachFeature = (feature, layer) => {
        layer.on('click', function (e) {
            if (feature.properties.NAME_1 === "Pavlodar") {
                const { lat, lng } = e.latlng;
                setSelectedPoint({
                    lat,
                    lng
                })
            }
        });
    };

    useEffect(() => {
        if (selectedPoint != null) {
            setLoading(true);
            message.loading(<IntlMessage id={'loading'}/>, 0);
            WeatherService.getOverallCATbyLocation(selectedPoint.lat, selectedPoint.lng)
                .then((r) => {
                    message.destroy();
                    message.success(<IntlMessage id={'success'}/>, 5);
                    setWeather(r.data);
                    setLoading(false);
                })
                .catch(() => {
                    message.destroy();
                    message.error(<IntlMessage id={'error'}/>, 5);
                    setLoading(false);
                })
        }
    }, [selectedPoint]);

    return (
        <Flex style={{width: "100%", position: "relative", backgroundColor: "#ECF4ED", paddingTop: 100, paddingBottom: 0}} vertical align={"center"} justify={"flex-start"} gap={30}>
            <Flex style={{width: "100%", maxWidth: "1440px", position: "relative"}} align={"center"} justify={"center"} gap={50} vertical>
                <Image preview={false} width={75} src={sun} wrapperStyle={{position: "absolute", top: -13, left: 0}}/>
                <Flex style={{width: "100%"}} align={"center"} justify={"center"} vertical>
                    <Fade triggerOnce cascade>
                        <p style={{color: "#416338", fontSize: "1.5rem", fontWeight: 900, textTransform: "uppercase", textAlign: "center"}}>
                            <IntlMessage id={'argoPage.header1'}/>
                        </p>
                        <p style={{color: "#83AA5E", fontSize: "1.5rem", fontWeight: 900, textTransform: "uppercase", textAlign: "center"}}>
                            <IntlMessage id={'argoPage.header2'}/>
                        </p>
                    </Fade>
                </Flex>

                <Flex style={{width: "100%", position: "relative"}} align={"center"} justify={"center"} vertical
                      wrap={"wrap"} gap={10}>
                    <Flex style={{width: "100%", position: "relative"}} align={"center"} justify={"center"} gap={30}>
                        <MapContainer center={[48.3831, 67.4986]} zoom={5} style={{ width: "60%", height: "600px", borderRadius: 30}}>
                            <LayersControl position="topright">
                                <BaseLayer checked name="Standard">
                                    <TileLayer
                                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                    />
                                </BaseLayer>
                                <BaseLayer name="OpenStreetMap">
                                    <TileLayer
                                        url="https://{s}.tile-cyclosm.openstreetmap.fr/cyclosm/{z}/{x}/{y}.png"
                                    />
                                </BaseLayer>
                                <BaseLayer name="Satellite">
                                    <TileLayer
                                        url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                                    />
                                </BaseLayer>
                            </LayersControl>
                            <GeoJSON data={kazakhstan} style={style} onEachFeature={onEachFeature}/>
                            {selectedPoint &&
                                <Marker position={selectedPoint} />
                            }
                        </MapContainer>
                        <Flex style={{
                            width: 300, padding: 30,
                            border: `2px solid #416338`, backgroundColor: "white",
                            height: "calc(600px - 60px)",
                            borderRadius: 30
                        }} align={"flex-start"} justify={"flex-start"} gap={20} vertical>
                            <MyText style={{fontWeight: 900, fontSize: "1.2rem"}}>
                                Выбранный объект
                            </MyText>
                            {
                                loading ?
                                    <>
                                        <Card type={"line"}/>
                                        <Card type={"line"}/>
                                        <Card type={"line"}/>
                                        <Card type={"line"}/>
                                        <Card type={"line"}/>
                                    </>
                                    :
                                    <>
                                        <MyText strong>
                                            Минимальная температура: <span>{weather && (Math.round(weather?.minTemp * 100) / 100).toFixed(2)}</span>
                                        </MyText>
                                        <MyText strong>
                                            Максимальная температура температура: <span>{weather && (Math.round(weather?.maxTemp * 100) / 100).toFixed(2)}</span>
                                        </MyText>
                                        <MyText strong>
                                            Средняя температура: <span>{weather && (Math.round(weather?.avgTemp * 100) / 100).toFixed(2)}</span>
                                        </MyText>
                                        <MyText strong>
                                            Атмосферное давление: <span>{weather && (Math.round(weather?.atmPressure * 100) / 100).toFixed(2)}</span>
                                        </MyText>
                                        <MyText strong>
                                            Сумма активных температур: <span>{weather && (Math.round(weather?.sumCAT * 100) / 100).toFixed(2)}</span>
                                        </MyText>
                                    </>
                            }


                            <br/>
                            <Flex vertical align={"flex-start"} justify={"flex-start"}>
                                <MyText uppercase strong>
                                    Прогноз урожайности:
                                </MyText>
                                {
                                    loading ?
                                        <Card type={"line"}/>
                                        :
                                        <MyText uppercase style={{fontWeight: 900, color: "#416338", fontSize: "1.2rem"}}>
                                            {
                                                weather &&
                                                <>
                                                    {weather?.sumCAT < 1500 && parseInt(Math.round((25 * 0.7)).toFixed(1)) + " "}
                                                    {weather?.sumCAT > 1600 && parseInt(Math.round((25 * 0.8)).toFixed(1)) + " "}
                                                    {weather?.sumCAT >= 1500 && weather?.sumCAT <= 1600 && "25 "}
                                                    центнеров/гектар
                                                </>
                                            }
                                        </MyText>
                                }

                            </Flex>
                        </Flex>
                    </Flex>
                </Flex>
            </Flex>
            <Flex style={{width: "calc(100% - 40px)", padding: 20,zIndex: 1, marginTop: 150, backgroundColor: "#83AA5E"}} align={"center"} justify={"center"}>
                <Image preview={false} width={125} src={aituLogo}/>
            </Flex>
            <Image preview={false} width={50} src={flower1} wrapperStyle={{position: "absolute", bottom: 100, left: "50%", transform: "translateX(-50%)"}}/>
            <Image preview={false} width={35} src={flower3} wrapperStyle={{position: "absolute", bottom: 100, left: "40%", transform: "translateX(-50%)"}}/>
            <Image preview={false} width={25} src={flower2} wrapperStyle={{position: "absolute", bottom: 100, left: "42%", transform: "translateX(-50%)"}}/>
            <Image preview={false} width={15} src={leaf1} wrapperStyle={{position: "absolute", bottom: 100, left: "30%", transform: "translateX(-50%)"}}/>
            <Image preview={false} width={15} src={leaf1} wrapperStyle={{position: "absolute", bottom: 100, left: "29%", transform: "translateX(-50%)"}}/>
            <Image preview={false} width={15} src={leaf1} wrapperStyle={{position: "absolute", bottom: 100, left: "28%", transform: "translateX(-50%)"}}/>
            <Image preview={false} width={15} src={leaf1} wrapperStyle={{position: "absolute", bottom: 100, left: "27%", transform: "translateX(-50%)"}}/>
            <Image preview={false} width={15} src={leaf1} wrapperStyle={{position: "absolute", bottom: 100, left: "26%", transform: "translateX(-50%)"}}/>
            <Image preview={false} width={35} src={leaf2} wrapperStyle={{position: "absolute", bottom: 100, left: "24%", transform: "translateX(-50%)"}}/>
            <Image preview={false} width={15} src={leaf1} wrapperStyle={{position: "absolute", bottom: 100, left: "22%", transform: "translateX(-50%)"}}/>
            <Image preview={false} width={15} src={leaf1} wrapperStyle={{position: "absolute", bottom: 100, left: "75%", transform: "translateX(-50%)"}}/>
            <Image preview={false} width={15} src={leaf1} wrapperStyle={{position: "absolute", bottom: 100, left: "73%", transform: "translateX(-50%)"}}/>
            <Image preview={false} width={45} src={leaf3} wrapperStyle={{position: "absolute", bottom: 100, left: "65%", transform: "translateX(-50%)"}}/>
            <Image preview={false} width={400} src={bottom_zigzag} wrapperStyle={{position: "absolute", bottom: 100, left: "70%", transform: "translateX(-50%)"}}/>

        </Flex>
    );
};

export default ArgoGisPage;